/**
 * WP-F12 — in-collection text search.
 * Narrows the currently-rendered product cards by title as the shopper types (instant,
 * no network). Shows a "Search all products for X" link for a full-catalogue query,
 * since Shopify has no free-text collection facet. Re-initialises after facet AJAX
 * re-renders the grid/panel. Drives both placements (filters panel + below the tag bar).
 */
(function () {
  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[^\w\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function init(root) {
    var input = root.querySelector('[data-wp-colsearch-input]');
    if (!input || input.dataset.bound === 'true') return;
    input.dataset.bound = 'true';
    var moreWrap = root.querySelector('[data-wp-colsearch-more]');
    var allLink = root.querySelector('[data-wp-colsearch-all]');
    var baseHref = allLink ? allLink.getAttribute('href').split('?')[0] : '';
    var t;

    function apply() {
      var raw = input.value.trim();
      var q = norm(raw);
      var cards = document.querySelectorAll('.product-grid__item, .resource-list__item');
      cards.forEach(function (li) {
        var titleEl = li.querySelector('.resource-card__title');
        var hay = norm((titleEl && titleEl.textContent) || li.textContent);
        li.hidden = q ? hay.indexOf(q) === -1 : false;
      });
      if (moreWrap && allLink) {
        if (raw) {
          allLink.textContent = 'Search all products for “' + raw + '” →';
          allLink.href = baseHref + '?type=product&q=' + encodeURIComponent(raw);
          moreWrap.hidden = false;
        } else {
          moreWrap.hidden = true;
        }
      }
    }

    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(apply, 120);
    });
    input.addEventListener('search', apply);
  }

  function boot() {
    document.querySelectorAll('[data-wp-colsearch]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Facet AJAX morphs the grid + filters panel, replacing the inputs — re-init.
  document.addEventListener('shopify:section:load', boot);
  try {
    var host = document.getElementById('ResultsList') || document.querySelector('.product-grid');
    var container = host ? host.closest('.shopify-section') || document.body : document.body;
    if (window.MutationObserver && container) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () { pending = false; boot(); });
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
